import script from "./invitation.vue?vue&type=script&setup=true&lang=js"
export * from "./invitation.vue?vue&type=script&setup=true&lang=js"

import "./invitation.vue?vue&type=style&index=0&id=27f1c0f8&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_influencer_admin_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27f1c0f8"]])

export default __exports__